/**
 * Runs `work`, falling back to `fallback` if it rejects or outruns `timeoutMs`.
 *
 * For best-effort reads whose caller must answer on a deadline — a slow
 * dependency degrades the response rather than withholding it.
 */
export async function withTimeout<T>(
  work: () => Promise<T>,
  timeoutMs: number,
  fallback: T,
): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  try {
    return await Promise.race([
      Promise.resolve()
        .then(work)
        .catch(() => fallback),
      new Promise<T>((resolve) => {
        timeoutId = setTimeout(resolve, timeoutMs, fallback);
      }),
    ]);
  } finally {
    clearTimeout(timeoutId);
  }
}
